import axios from 'axios';
import SignupSuccess from '../components/SignupSuccess';

const baseLink = process.env.REACT_APP_BASE_LINK;
const SignupSuccessContainer = () => {
    /* callback function called when login button is clicked after successful Signup */
    const onLogin = async () => {
        const { data } = await axios({
            url: `${baseLink}api/signin`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (data.url) {
            window.location.href = data.url;
        }
    };
    return (
        <SignupSuccess onLogin={onLogin} />
    );
};

export default SignupSuccessContainer;
